export default {
  eyebrow: 'Portal partener',
  title: 'Facturare',
  description: 'Metoda de plată pentru factura lunară de platformă și fiecare factură cu detaliile complete.',
  toasts: {
    checkout_error: 'Checkout-ul nu a putut fi inițiat — vă rugăm încercați din nou.',
    action_error: 'Acțiunea a eșuat — vă rugăm încercați din nou.',
    onboarding_error: 'Verificarea nu a putut fi pornită — te rugăm să încerci din nou.',
    payment_method_in_use:
      'Licențele restaurantelor tale sunt facturate pe această metodă de plată, deci nu poate fi eliminată. Înlocuiește-o cu una nouă.',
  },
  payout_bank_account: {
    title: 'Cont bancar pentru plăți',
    description: 'Plățile din comisionul de venituri se fac în {{currency}}. Stripe convertește transferul la primire.',
    toasts: {
      saved: 'Cont bancar salvat',
      save_failed: 'Nu am putut salva contul bancar. Verifică datele.',
    },
  },
  payout_onboarding: {
    title: 'Configurează contul de plată',
    description:
      'Cota ta din venituri este plătită lunar către un cont de plată Stripe. Finalizează verificarea o singură dată — plățile rămân în așteptare până atunci.',
    missing: {
      title: 'Încă necesar înainte ca plățile să poată începe:',
      bank_account: 'Adaugă contul bancar în care ar trebui plătită cota ta din venituri.',
      business_details: 'Completează detaliile companiei, precum adresa, codul fiscal sau numărul de înregistrare.',
      people: 'Adaugă detaliile reprezentantului companiei, ale proprietarilor sau directorilor.',
      documents: 'Încarcă documentele de verificare solicitate de Stripe.',
      terms: 'Acceptă termenii și condițiile Stripe.',
      other: 'Furnizează detaliile rămase solicitate de Stripe.',
    },
    start: 'Începe verificarea',
    continue: 'Continuă verificarea',
    ready: 'Cont de plată verificat — cota ta din venituri este plătită automat după fiecare ciclu de facturare.',
  },
  payment_method: {
    title: 'Metodă de plată',
    empty: 'Nicio metodă de plată înregistrată — factura lunară nu poate fi colectată automat încă.',
    add: 'Adaugă metodă de plată',
    replace: 'Înlocuiește',
    remove: 'Elimină',
    remove_confirm: {
      title: 'Eliminați această metodă de plată?',
      description:
        'Cardul/mandatul este detașat imediat din Stripe. Fără o metodă de plată, facturile — inclusiv cele deja emise — sunt colectate prin factura găzduită Stripe în loc de automat.',
      confirm: 'Elimină',
    },
  },
  invoices: {
    title: 'Facturi',
  },
};
